import { supabase } from "../supabase";
import type { Profile } from "../types";

interface ProfileRow {
  id: string;
  auth_user_id: string | null;
  school_id: string;
  role: string;
  name: string;
  initials: string;
  color: string;
}

const COLS = "id, auth_user_id, school_id, role, name, initials, color";

function mapProfile(r: ProfileRow): Profile {
  return {
    id: r.id,
    schoolId: r.school_id,
    authUserId: r.auth_user_id,
    role: r.role,
    name: r.name,
    initials: r.initials,
    color: r.color,
  };
}

export async function listBySchool(schoolId: string): Promise<Profile[]> {
  const { data, error } = await supabase
    .from("profiles")
    .select(COLS)
    .eq("school_id", schoolId)
    .order("created_at", { ascending: true });
  if (error) throw error;
  return (data as ProfileRow[]).map(mapProfile);
}

export async function byId(id: string): Promise<Profile | null> {
  const { data, error } = await supabase
    .from("profiles")
    .select(COLS)
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data ? mapProfile(data as ProfileRow) : null;
}

export async function byAuthUserId(authUserId: string): Promise<Profile | null> {
  const { data, error } = await supabase
    .from("profiles")
    .select(COLS)
    .eq("auth_user_id", authUserId)
    .maybeSingle();
  if (error) throw error;
  return data ? mapProfile(data as ProfileRow) : null;
}
